import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
export function useShowMoreVisibility(initiallyVisible) {
  const $ = _c(5);
  const [manualOverride, setManualOverride] = useState(null);
  const overrideValue = manualOverride?.source === initiallyVisible ? manualOverride.value : null;
  const showMoreVisible = overrideValue ?? initiallyVisible;
  let t0;
  if ($[0] !== initiallyVisible) {
    t0 = visible => {
      setManualOverride(previous => {
        if (previous?.source === initiallyVisible && previous.value === visible) {
          return previous;
        }
        return {
          value: visible,
          source: initiallyVisible
        };
      });
    };
    $[0] = initiallyVisible;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleShowMoreVisibility = t0;
  let t1;
  if ($[2] !== handleShowMoreVisibility || $[3] !== showMoreVisible) {
    t1 = {
      showMoreVisible,
      handleShowMoreVisibility
    };
    $[2] = handleShowMoreVisibility;
    $[3] = showMoreVisible;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}